export default function Banner({message, icon, color}){
    return(
        <div className="flex items-center justify-center align-middle pt-4">
            <div className="text-2xl text-center text-gray-700 font-bold bg-amber-300 flex items-center justify-center w-5/6 p-2 align-middle  rounded-xl border-0">
                <div className="p-1 font-bold">{icon}</div> {message} <div className="p-1 font-bold">{icon}</div>
            </div>
        </div>
    )
}